export enum CareAssessmentsRoutes {
  CARE_ASSESSMENTS_QUESTIONNAIRE = 'careAssessmentsQuestionnaire',
  CARE_ASSESSMENTS_RETAKE = 'careAssessmentsRetake',
}

export const ALLOWED_FEEDBACK_LOCALES = ['en_GB', 'en_AU', 'en_CA', 'en_US'];
